/** biome-ignore-all lint/suspicious/noBitwiseOperators: <explanation> */

// Source: https://stackoverflow.com/a/8831937/2147719
// Generate a hash from an input string.
// The result is in the range [-2^31 - 2^31[
// If limit is specified, result is in range [0 - limit[
export const simpleHash = (input: string, limit?: number) => {
	let hash = 0
	if (input.length === 0) {
		return hash
	}
	for (let i = 0; i < input.length; i++) {
		hash = (hash << 5) - hash + input.charCodeAt(i)
		hash &= hash // Convert to 32bit integer
	}
	return limit ? ((hash % limit) + limit) % limit : hash
}
